export default __webpack_public_path__ + "static/ChatIcon-3f0481073eed7465cc21142287e3db59.webp";